import React from 'react';
import { getAsLongDate, getTimeOnly, formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { Tooltip, Whisper } from 'rsuite';
import { Typography } from '@mui/material';
import SegmentList from './SegmentList';
import { SymbolicAmount } from '../../../Enums';
import './SegmentTooltip.scss';

/** @typedef {'click' | 'hover' | 'focus' | 'active' | 'contextMenu' | 'none'} OverlayTriggerType */

/**
 * @typedef {object} SegmentTooltipProps
 * @property {object} SegmentTooltipProps.data `data` should be a shift object containing segments
 * @property {boolean} SegmentTooltipProps.isPartial
 * @property {OverlayTriggerType} SegmentTooltipProps.trigger - How the tooltip should be triggered
 */

/**
 * @param {import('rsuite').WhisperProps & SegmentTooltipProps} props
 */
const SegmentTooltip = ({
	children,
	data,
	isPartial,
	isVto,
	isOpenShift = false,
	originalShift,
	trigger = "hover",
	placement = "right",
	style = {},
	isSignUp = false,
	selectedAssignmentName,
	...props
}) => {
	let timeOffRequest = '';
	if (!!props.timeOffRequest && props.timeOffRequest?.periods?.length > 0) {
		const [period] = props.timeOffRequest?.periods;

		const periodDuration = (period.symbolicAmount.id === SymbolicAmount.hours && period.duration > 0)
			? ` ${getTimeOnly(period.startDate.replace("00:00:00", period.startTime))} (${period.duration})`
			: '';
		timeOffRequest = (
			<div className="time-off-request-wrapper">
				<Typography>Time-off request</Typography>
				<span className="text-md-medium">{`(${getAsLongDate(period.startDate)}) ${period.payCode.qualifier} ${periodDuration}`}</span>
			</div>
		);
	}

	return (
		<Whisper
			{...props}
			trigger={trigger}
			placement={placement}
			controlId={`control-id-${placement}`}
			speaker={
				<Tooltip className="segment-tooltip"
					style={style}
				>
					<SegmentList
						data={data}
						isVto={isVto}
						isOpenShift={isOpenShift}
						isPartial={isPartial}
						isSignUp={isSignUp}
						selectedAssignmentName={selectedAssignmentName}
					></SegmentList>
					{timeOffRequest}
					{isPartial && (
						<>
							<Typography>Partial shift of:</Typography>
							<SegmentList data={originalShift}></SegmentList>
						</>
					)}
				</Tooltip>
			}
		>
			{children}
		</Whisper>
	);
};

export default SegmentTooltip